import { render, staticRenderFns } from "./PropertySelect.vue?vue&type=template&id=2cf0dbf3&"
import script from "./PropertySelect.vue?vue&type=script&lang=js&"
export * from "./PropertySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports